import { render, staticRenderFns } from "./MathTrainer.vue?vue&type=template&id=d0f46c96&scoped=true"
import script from "./MathTrainer.vue?vue&type=script&lang=js"
export * from "./MathTrainer.vue?vue&type=script&lang=js"
import style0 from "./MathTrainer.vue?vue&type=style&index=0&id=d0f46c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f46c96",
  null
  
)

export default component.exports